import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../AppIcon';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const footerLinks = {
            product: [
              { label: 'Features', path: '/features' },
              { label: 'Pricing', path: '/pricing' },
              { label: 'Desktop App', path: '/desktop-app' }
            ],
            support: [
              { label: 'Support', path: '/support' }
            ],
            company: [
              { label: 'About', path: '/about' },
              { label: 'Privacy Policy', path: '/privacy' },
              { label: 'Downloads', path: '/downloads' }
            ]
  };

  const socialLinks = [
    { name: 'Twitter', icon: 'Twitter', url: 'https://twitter.com' },
    { name: 'Facebook', icon: 'Facebook', url: 'https://facebook.com' },
    { name: 'Instagram', icon: 'Instagram', url: 'https://instagram.com' },
    { name: 'Linkedin', icon: 'Linkedin', url: 'https://linkedin.com' }
  ];

  return (
    <footer className="bg-card border-t border-border">
      <div className="container mx-auto px-6 lg:px-12 py-12 lg:py-18">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 lg:gap-8">
          <div className="lg:col-span-2">
                    <Link to="/home" className="flex items-center space-x-3 mb-6">
                      <img src="/logo-light.png" alt="Cultaz" className="h-8 w-auto mb-4 dark:hidden" />
                      <img src="/logo-dark.png" alt="Cultaz" className="h-8 w-auto mb-4 hidden dark:block" />
            </Link>
            <p className="font-body text-base text-muted-foreground mb-6 max-w-md">
              Hybrid retail management software designed for Nigerian retailers. Seamlessly manage your business with cloud convenience and offline reliability.
            </p>
            <div className="flex items-center space-x-4">
              {socialLinks?.map((social) => (
                <a
                  key={social?.name}
                  href={social?.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex h-10 w-10 items-center justify-center rounded-lg border border-border bg-card transition-smooth hover:bg-muted hover:scale-105 focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3"
                  aria-label={social?.name}
                >
                  <Icon name={social?.icon} size={18} color="var(--color-foreground)" strokeWidth={2} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-lg font-semibold text-foreground mb-4">Product</h3>
            <ul className="space-y-3">
              {footerLinks?.product?.map((link) => (
                <li key={link?.path}>
                  <Link
                    to={link?.path}
                    className="font-body text-base text-muted-foreground transition-smooth hover:text-primary"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-lg font-semibold text-foreground mb-4">Support</h3>
            <ul className="space-y-3">
              {footerLinks?.support?.map((link) => (
                <li key={link?.path}>
                  <Link
                    to={link?.path}
                    className="font-body text-base text-muted-foreground transition-smooth hover:text-primary"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-lg font-semibold text-foreground mb-4">Company</h3>
            <ul className="space-y-3">
              {footerLinks?.company?.map((link) => (
                <li key={link?.path}>
                  <Link
                    to={link?.path}
                    className="font-body text-base text-muted-foreground transition-smooth hover:text-primary"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-border mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="font-body text-sm text-muted-foreground">
              © {currentYear} Cultaz. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <Link
                to="/privacy"
                className="font-body text-sm text-muted-foreground transition-smooth hover:text-primary"
              >
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;